import { Loader } from '@googlemaps/js-api-loader';
import store from '../global/store';
import { tracker } from '../global/tracker';
import { LocalStorageService } from './local-storage-service';

class _BankSearchService {
  bankSearchApi: string;

  googleApiKey: string;

  /**
   * Temporarily disable tracking and saving to localStorage
   * while restoring previously saved search values.
   */
  isCurrentlyRestoring = false;

  hasGoogleMapsConsent = false;

  init(element: HTMLElement, bankSearchApi: string, googleApiKey: string) {
    //
    element.addEventListener('uiInputClear', () => {
      LocalStorageService.removeSearchValues();
    });

    this.bankSearchApi = bankSearchApi;
    this.googleApiKey = googleApiKey;

    // provide loadMore() to store
    store.state.loadMore = this.loadMore;

    // add change listeners
    store.onChange('selectedPlaceName', () => {
      LocalStorageService.saveSearchValues();
    });
    store.onChange('selectedBank', () => {
      LocalStorageService.saveSearchValues();
    });
    store.onChange('selectedPlaceLocation', () => {
      this.onSelectedPlaceLocationChange();
    });
    store.onChange('activeFilterValue', () => {
      this.onFilterChange();
    });

    // listen for UserCentrics consent
    document.body.addEventListener(
      'newConsentStatus',
      this.onNewConsentStatus.bind(this)
    );
  }

  private onSelectedPlaceLocationChange() {
    if (store.state.selectedPlaceLocation) {
      this.fetchBankData(
        store.state.selectedPlaceLocation,
        store.state.activeFilterValue
      );
      store.state.resultsVisibleCount = 5;
    }
    LocalStorageService.saveSearchValues();
  }

  private onFilterChange() {
    tracker.trackFilterChange();
    this.fetchBankData(
      store.state.selectedPlaceLocation,
      store.state.activeFilterValue
    );
  }

  private onNewConsentStatus(ev) {
    if (ev.detail.googleMaps && !this.hasGoogleMapsConsent) {
      this.hasGoogleMapsConsent = true;
      this.initGoogleMaps();
    }
  }

  private async initGoogleMaps() {
    const loader = new Loader({
      apiKey: this.googleApiKey,
      version: 'weekly',
      libraries: ['places', 'geometry', 'marker'],
    });
    store.state.google = await loader.load();
    LocalStorageService.restoreSearchValues();
  }

  private async fetchBankData(location: google.maps.LatLng, filter?: string) {
    // store.state.isCurrentlyRestoring will already have been reset to false by the time
    // fetch() resolves, so we need to cache its value NOW to use it AFTER fetch().
    const skipTracking = store.state.isCurrentlyRestoring;

    store.state.resultsTotal = await fetch(this.bankSearchApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        filter: [filter],
        lat: location.lat(),
        limit: 30,
        lng: location.lng(),
      }),
    }).then((r) => r.json());

    // Do NOT track while restoring search values. Tracking should only fire upon user interaction
    if (!skipTracking) tracker.trackExecuteBankSearch();
  }

  private loadMore = () => {
    if (store.state.resultsVisibleCount < store.state.resultsTotal.length) {
      store.state.resultsVisibleCount += 5;
      tracker.trackLoadMore();
    }
  };
}

export const BankSearchService = new _BankSearchService();
